import './Header.scss';
import { HeaderPopup } from './Popup';

const replaceSearchButton = () => {
    const link = document.querySelector('.header__action-button--search');
    if (link) {
        const button = document.createElement('BUTTON');
        button.innerHTML = link.innerHTML;
        button.className = link.className;
        button.setAttribute('aria-controls', link.getAttribute('aria-controls'));
        link.parentElement.insertBefore(button, link);
        link.remove();
    }
};
replaceSearchButton();

HeaderPopup.init();

/**
 * Round a number to a given precision
 * @param {number} num
 * @param {number} precision
 * @return {number}
 */
const round = (num, precision = 3) => {
    const f = Math.pow(10, precision);
    return Math.round(num * f) / f;
};

const stickyHeader = () => {
    const header = document.querySelector('.header');
    if (!header) {
        return;
    }

    const nav = header.querySelector('.header__navigation');
    if (!nav) {
        return;
    }

    let isInit = false;

    const onScroll = () => {
        const offsetTop = window.scrollY;
        const navOffset = nav.offsetTop - 8;

        // avoid further calculation when we scroll lower within the page
        if (isInit && offsetTop > navOffset + 500) {
            return;
        }

        const progressIntoHeader = offsetTop > 0 ? round(Math.max(0, Math.min(1, offsetTop / navOffset))) : 0;

        header.style.setProperty('--scroll-offset', `-${progressIntoHeader * navOffset}px`);
        header.style.setProperty('--scroll-progress', progressIntoHeader);
        isInit = true;
    };

    /**
     * Restore the header into view when top-half header-content is moved out of the viewport
     * @param {FocusEvent} e
     */
    const onBlur = (e) => {
        const target = e.relatedTarget;
        const focusInHeader = target && header.contains(target) && !nav.contains(target);

        const className = 'header--focus';
        const hadClass = header.classList.contains(className);
        header.classList.toggle(className, focusInHeader);

        // when jumping through the content, the scroll update might not update
        if (!focusInHeader && hadClass === focusInHeader) {
            onScroll();
        }
    };

    window.addEventListener('scroll', onScroll);
    document.addEventListener('blur', onBlur, true);

    return () => {
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('focus', onBlur);
    };
};

stickyHeader();
